import React from "react";
import { SInput, SLabel, SInputWrapper, SErrorMessage } from "./styled/SInput";
import { Icon } from "../../components";

interface InputProps {
  placeholder?: string;
  id: string;
  name: string;
  type: string;
  icon?: string;
  label?: string;
  error?: string;
  touched?: boolean;
  value?: string;
  disabled?: boolean;
  required?: boolean;
}

function Input(props: InputProps) {
  return (
    <React.Fragment>
      {props.label && (
        <SLabel htmlFor={props.name}>
          {props.label}{" "}
          <span className="asterisk">{props.required && "*"}</span>
        </SLabel>
      )}
      <SInputWrapper>
        <React.Fragment>
          {props.error && props.touched ? (
            <Icon name="cross" color="#cc0033" />
          ) : (
            props.icon && <Icon name={props.icon} />
          )}
        </React.Fragment>
        <SInput
          disabled={props.disabled}
          error={props.touched ? props.error : ""}
          placeholder={props.placeholder}
          name={props.name}
          value={props.value}
          type={props.type}
          id={props.id}
          autocomplete="off"
        />
        {props.error && (
          <SErrorMessage id={`error-${props.id}`}>
            {props.touched && props.error}
          </SErrorMessage>
        )}
      </SInputWrapper>
    </React.Fragment>
  );
}

export default Input;
